import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/', // 首页
    name: 'Home',
    component: () => import('../views/home/Index.vue')
  },
  {
    path: '/error', // 异常页
    name: 'error',
    component: () => import('../views/error/error.vue')
  },
  {
    path: '/mobile', // 异常页
    name: 'mobile',
    component: () => import('../views/mobile/Index.vue')
  },
  {
    path: '/login', // 登录页
    name: 'Login',
    component: () => import('../views/login/Index.vue')
  },
  {
    path: '/register', // 注册页面
    name: 'register',
    meta: {
      isLogin: true
    },
    component: () => import('../views/register/Register.vue')
  },
  {
    path: '/judge', // 注册页面
    name: 'judge',
    // meta: {
    //   isLogin: true
    // },
    component: () => import('../views/register/RegisterJudge.vue')
  },
  {
    path: '/register-status', // 注册状态页
    name: 'register-status',
    meta: {
      isLogin: true
    },
    component: () => import('../views/register/RegisterStatus.vue')
  },
  {
    path: '/sale_info', // 购票须知
    name: 'Sale_Info',
    component: () => import('../views/saleInfo/Index.vue')
  },
  {
    path: '/park_notice', // 公告页面
    name: 'Park_Notice',
    component: () => import('../views/parkNotice/Index.vue')
  },
  {
    path: '/park_notice/notice', // 公告详细页
    name: 'notice0',
    component: () => import('../components/information/notice/detail/Detail.vue')
  },
  {
    path: '/order', // 订单页
    name: 'Order',
    meta: {
      isLogin: true
    },
    component: () => import('../views/order/Index.vue'),
    children: [
      {
        path: '', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'My_Order', // 我的订单
        component: () => import('../views/modules/MyOrder.vue')
      },
      {
        path: '/order/detail/list', // 订单详细页
        name: 'order_detail_list',
        component: () => import('../views/modules/detail/OrderDetail.vue')
      },
      {
        path: 'order-refund', // 批量退票页
        name: 'order-refund',
        component: () => import('../views/refund/OrderRefund.vue')
      },
      {
        path: 'presonal', // 个人信息页
        name: 'Presonal',
        component: () => import('../views/modules/Presonal.vue')
      },
      {
        path: 'connect', // 联系人页
        name: 'Connect',
        component: () => import('../views/modules/Connect.vue')
      },
      {
        path: 'invoice', // 发票页
        name: 'Invoice',
        component: () => import('../views/modules/Invoice.vue')
      },
      {
        path: 'create-invoice', // 开发票页
        name: 'create-invoice',
        component: () => import('@/views/modules/CreateInvoice.vue')
      }
    ]
  },
  {
    path: '/order/invoice-end', // 发票状态
    name: 'invoice-end',
    meta: {
      isLogin: true
    },
    component: () => import('@/views/modules/InvoiceEnd.vue')
  },
  {
    path: '/user_info',
    name: 'User_Info',
    meta: {
      isLogin: true
    },
    component: () => import('../views/userInfo/Index.vue'),
    children: [
      {
        path: 'uorder', // 以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'User_My_Order', // 我的订单
        component: () => import('../views/modules/MyOrder.vue')
      },
      {
        path: '/order/detail/list', // 订单详细页
        name: 'order_detail_list',
        component: () => import('../views/modules/detail/OrderDetail.vue')
      },
      {
        path: 'order-refund', // 批量退票页
        name: 'order-refund',
        component: () => import('../views/refund/OrderRefund.vue')
      },
      {
        path: '', // 个人信息页
        name: 'UPresonal',
        component: () => import('../views/modules/Presonal.vue')
      },
      {
        path: 'connect', // 联系人页
        name: 'Connect',
        component: () => import('../views/modules/Connect.vue')
      },
      {
        path: 'uinvoice', // 发票页
        name: 'UInvoice',
        component: () => import('../views/modules/Invoice.vue')
      },
      {
        path: 'create-uinvoice', // 开发票页
        name: 'create-invoice',
        component: () => import('@/views/modules/CreateInvoice.vue')
      }
    ]
  },
  {
    path: '/purchase/list', // 购票列表
    name: 'purchase-list',
    meta: {
      isLogin: true
    },
    component: () => import('../views/purchase/List/index.vue')
  },
  {
    path: '/purchase/group', // 团体购票页面
    name: 'purchase-group',
    meta: {
      isLogin: true
    },
    component: () => import('../views/purchase/Info/group.vue')
  },
  {
    path: '/purchase/individual', // 散客购票页面
    name: 'purchase-individual',
    component: () => import('../views/purchase/Info/individual.vue')
  },
  {
    path: '/purchase/pay', // 支付页面
    name: 'purchase-pay',
    meta: {
      isLogin: true
    },
    component: () => import('../views/purchase/Pay/index.vue')
  },
  {
    path: '/purchase/end', // 支付完成页面
    name: 'purchase-pay-end',
    meta: {
      isLogin: true
    },
    component: () => import('../views/purchase/PayEnd/index.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  let token = Vue.ls.get('token')
  let type = Vue.ls.get('type')
  if (to.name === 'Login') {
    let obj = {}
    if (token && type !== null) {
      obj = { path: "/" }
    }
    next(obj)
  } else if (to.name.indexOf('register') > -1) {
    let obj = {}
    let group = Vue.ls.get('group')
    if (!token) token = store.state.token
    if (!type) type = store.state.type
    if (token && type !== null) {
      next()
    } else if (group) {
      next()
    } else {
      obj = {
        path:"/login",
        query:{
          redirect: to.fullPath
        }
      }
    }
    next(obj)
  } else if (to.matched.some(res=>res.meta.isLogin)) {//判断是否需要登录
    if (token && type !== null) {
      next()
    } else {
      let obj = {}
      if (to.query.user) {
        if (to.query.user !== 'person') {
          obj = {
            path:"/login",
            query:{
              redirect: to.fullPath,
              user: to.query.user
            }
          }
        }
      } else {
        obj = {
          path:"/login",
          query:{
            redirect: to.fullPath
          }
        }
      }
      next(obj)
    }
  }else{
    next()
  }
})

export default router
